import { FormControl } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';

export enum ALUNewRequestAdditionalControlName {
  ExclusionPurpose = 'exclusionPurpose',
  InvestmentCommencementDate = 'investmentCommencementDate',
  LandValue = 'landValue',
}

export const ALUNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...ALUNewRequestAdditionalControlName,
};

export interface ALUNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [ALUNewRequestControlName.ExclusionPurpose]: FormControl<number>;
  [ALUNewRequestControlName.InvestmentCommencementDate]: FormControl<NgbDateStruct>;
  [ALUNewRequestControlName.LandValue]: FormControl<number>;
}
